import {Partnerships, PlatformPreview, Impact, AboutHero, AboutContact} from "../../components/Public";

export default function AboutPage() {
    return <>
        <AboutHero/>
        <PlatformPreview/>
        <Impact/>
        <Partnerships/>
        <AboutContact/>
    </>
}